<template>
  <a
    :class="['zg-link-button', {
      [`zg-link-button--${size}`]: size,
      'zg-link-button--full-width': fullWidth,
      'zg-link-button--disabled': disabled,
    }]"
    :href="link"
    @click="$emit('click')"
  >
    <zg-icon
      v-if="icons && icons.left"
      :icon="icons.left"
      :size="size"
      :rotate="icons.leftRotation"
    />

    <slot />

    <zg-icon
      v-if="icons && icons.right"
      :icon="icons.right"
      :size="size"
      :rotate="icons.rightRotation"
    />
  </a>
</template>

<script>
  import ZgIcon from '../ZgIcon/ZgIcon.vue'

  export default {
    name: 'ZgLinkButton',
    components: {
      ZgIcon
    },
    props: {
      icons: {
        type: Object,
        required: false,
        default: () => ({
          left: null,
          leftSize: null,
          leftRotation: 0,
          right: null,
          rightSize: null,
          size: null
        })
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false
      },
      link: {
        type: String,
        required: true
      },
      fullWidth: {
        type: Boolean,
        required: false,
        default: false
      },
      size: {
        type: String,
        required: false,
        default: 'small'
      }
    }
  }
</script>

<style lang="scss" scoped>
  .zg-link-button {
    @include type-title-xxs;

    display: inline-flex;
    white-space: nowrap;
    align-items: center;
    cursor: pointer;
    outline: none;
    color: color(black);
    transition: all 0.3s ease;
    width: fit-content;
    margin: 0;
    gap: rhythm(xsmall);

    &:hover {
      color: color(brand-500);

      ::v-deep svg {
        fill: color(brand-500);
        transition: all 0.3s ease;
      }
    }

    &:focus {
      box-shadow: box-shadow(focus);
    }

    &:focus:not(:focus-visible) {
      box-shadow: none;
    }

    svg {
      color: color(black);
      fill: color(black);
    }

    &--full-width {
      justify-content: space-between;
    }

    &--disabled {
      @include disabled;
    }

    &--xsmall {
      @include type-title-xxs;
      margin: 0
    }

    &--small {
      @include type-title-xs;
      margin: 0
    }

    &--medium {
      @include type-title-s;
      margin: 0
    }

    &--large {
      @include type-title-m;
      margin: 0
    }

    @include mq(medium) {
      margin: 0;
      gap: rhythm(xsmall);
    }
  }

  a {
    border-bottom: none;
  }
</style>
